export interface DashboardGroup {
  groupId: number;
  name: string;
  machinesCount: number;
  groupsCount: number;
  disabled: boolean;
  statusGroupPageData?: StatusGroupPageData;
}

export interface StatusGroupPageData {
  [STATUS_GROUP_PAGE_DATA_KEYS.FAILURE]?: number;
  [STATUS_GROUP_PAGE_DATA_KEYS.WARNING]?: number;
  [STATUS_GROUP_PAGE_DATA_KEYS.INFO]?: number;
  [STATUS_GROUP_PAGE_DATA_KEYS.DEBUG]?: number;
  [STATUS_GROUP_PAGE_DATA_KEYS.INHIBIT]?: number;
  [STATUS_GROUP_PAGE_DATA_KEYS.OFFLINE]?: number;
}

export enum STATUS_GROUP_PAGE_DATA_KEYS {
  FAILURE = 'numberOfMachinesWithFailure',
  WARNING = 'numberOfMachinesWithWarning',
  INFO = 'numberOfMachinesWithInfo',
  DEBUG = 'numberOfMachinesWithDebug',
  INHIBIT = 'numberOfMachinesWithInhibit',
  OFFLINE = 'numberOfMachinesWithOffline',
}

export enum GROUP_ITEM_FOLDER_CLASS {
  FAILURE = 'failure',
  WARNING = 'warning',
  OFFLINE = 'offline',
  INFO = 'info',
  DEBUG = 'debug',
  INHIBIT = 'inhibit',
}
